var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"decrypt"},[_c('div',{attrs:{"id":"topbar"}},[_vm._v("Your Secret Santa Assignment is...")]),_c('h1',{staticClass:"yourPerson"},[_vm._v(_vm._s(this.res))])])
}
var staticRenderFns = []

export { render, staticRenderFns }